import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="w-full border-t border-border bg-background/80 backdrop-blur-sm mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          {/* Copyright */}
          <p className="text-center sm:text-left">
            © {currentYear} Fortified Mind. All rights reserved.
          </p>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link
              to="/terms-of-service"
              className="hover:text-foreground transition-colors duration-200 underline-offset-2 hover:underline"
            >
              Terms &amp; Conditions
            </Link>
            <span className="text-border hidden sm:inline">|</span>
            <Link
              to="/privacy-policy"
              className="hover:text-foreground transition-colors duration-200 underline-offset-2 hover:underline"
            >
              Privacy Policy
            </Link>
            <span className="text-border hidden sm:inline">|</span>
            <Link
              to="/contact-us"
              className="hover:text-foreground transition-colors duration-200 underline-offset-2 hover:underline"
            >
              Contact Us
            </Link>
            <span className="text-border hidden sm:inline">|</span>
            <Link
              to="/about"
              className="hover:text-foreground transition-colors duration-200 underline-offset-2 hover:underline"
            >
              About Fortified Mind
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
